const initialState = {};

export function AuthReducers(state = initialState, action) {
  switch (action?.type) {
    case 'USER_INFO':
      return {
        ...state,
        user: action.payload?.user,
        token: action?.payload?.token,
      };
    case 'LOGOUT_ACTION':
      return { ...state, user: {}, token: undefined };
    case 'USER_INFO_FETCHED':
      return { ...state, user: action.payload };
    case 'USER_ADDRESSES':
      return { ...state, billingAddresses: [...action.payload] };
    case 'GET_USER_ORDERS':
      return { ...state, orders: [...action.payload] };

    default:
      return state;
  }
}
